export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/greeting_cards_videos.d306547.svg";